interface CounterData {
  [key: string]: string | number;
}

function stringifyData(data: CounterData): string {
  return (
    "?" +
    Object.keys(data)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
      .join("&")
  );
}

function isValidBrand(brand: NavigatorUABrandVersion): boolean {
  if (brand.brand.includes("\\")) return false;
  if (brand.brand.includes("=")) return false;
  if (brand.brand.includes(";")) return false;
  if (brand.brand.includes("Brand")) return false;
  return true;
}

async function appendHighEntropyValues(data: CounterData) {
  if (navigator.userAgentData) {
    const ua = await navigator.userAgentData.getHighEntropyValues([
      "model",
      "platform",
      "platformVersion",
    ]);
    if (ua.brands) {
      for (const brand of ua.brands) {
        if (isValidBrand(brand)) {
          data.b = brand.brand;
          data.bv = brand.version;
        }
      }
    }
    if (ua.platform) data.s = ua.platform;
    if (ua.platformVersion) data.sv = ua.platformVersion;
    if (ua.model) data.m = ua.model;
  }
}

function setValue(id: string, value: string | number | undefined) {
  const element = document.getElementById(id);
  if (element && value) {
    (element as HTMLInputElement).value = value.toString();
  }
}

function setFormValues(data: CounterData) {
  setValue("hev-brand", data.b);
  setValue("hev-brand-version", data.bv);
  setValue("hev-platform", data.s);
  setValue("hev-platform-version", data.sv);
  setValue("hev-model", data.model);
}

export async function count() {
  const loc = window.location;
  if (loc.host === "") {
    return;
  }

  const site_code = "aaaa";
  let path = loc.pathname + loc.search;
  if (!path) path = "/";

  const hostname = loc.protocol + "//" + loc.hostname;
  const referrer = document.referrer;

  const data: CounterData = {
    c: site_code,
    p: path,
    h: hostname,
    r: referrer,
    x: window.screen.width,
    y: window.screen.height,
    z: window.devicePixelRatio || 1,
    a: Math.random().toString(36).substring(2, 8),
  };

  await appendHighEntropyValues(data);
  setFormValues(data);

  const img = document.createElement("img");
  img.setAttribute("alt", "");
  img.setAttribute("aria-hidden", "true");
  img.style.position = "absolute";
  img.style.bottom = "0";
  img.style.width = "1px";
  img.style.height = "1px";
  img.src = "/blank.gif" + stringifyData(data);
  img.addEventListener("load", function () {
    document.body.removeChild(img);
  });

  document.body.appendChild(img);
}
